import { useCallback } from "react";
import { useTranslation } from "react-i18next";

/**
 * The protocol form's texts (`courses.progress.form.*`). Names and times are put in as they
 * are: i18next would escape an "&" in a name, and React escapes anyway.
 */
export function useProtocolText() {
	const { t } = useTranslation();

	return useCallback(
		(key: string, options: Record<string, unknown> = {}) =>
			t(`courses.progress.form.${key}`, { ...options, interpolation: { escapeValue: false } }),
		[t]
	);
}
